import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteCompetitionStart:
    '[delete competition calendar plan] Delete competition calendar plan start',
  deleteCompetitionSuccess:
    '[delete competition calendar plan] Delete competition calendar plan success',
  deleteCompetitionFailure:
    '[delete competition calendar plan] Delete competition calendar plan failure',
}

export const actionTypes = {
  deleteCompetition:
    '[delete competition calendar plan] Delete calendar plan competition',
}

const mutations = {
  [mutationTypes.deleteCompetitionStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteCompetitionSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteCompetitionFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteCompetition](context, {id}) {
    context.commit(mutationTypes.deleteCompetitionStart)
    return new Promise((resolve) => {
      apiCompetitions
        .deleteCompetitionCalendarPlan(id)
        .then((response) => {
          context.commit(mutationTypes.deleteCompetitionSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteCompetitionFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
